import React, { useState } from 'react';
import './ChartFigure.css';

/**
 * A chart with its data-table alternative (spec §13: every chart has one).
 * The chart is an image to assistive tech, labelled by `summary`; "Show data
 * table" swaps it for the table, which carries the same numbers.
 */
export function ChartFigure({ title, summary, chart, table, actions }: {
    title: React.ReactNode;
    /** One sentence naming what the chart shows; the chart's accessible name. */
    summary: string;
    chart: React.ReactNode;
    table: React.ReactNode;
    actions?: React.ReactNode;
}) {
    const [asTable, setAsTable] = useState(false);
    return (
        <figure className="chart-figure">
            <figcaption className="chart-figure-head">
                <span className="chart-figure-title">{title}</span>
                <span className="chart-figure-actions no-print">
                    {actions}
                    <button type="button" className="btn btn-ghost btn-sm" aria-pressed={asTable} onClick={() => setAsTable(v => !v)}>
                        {asTable ? 'Show chart' : 'Show data table'}
                    </button>
                </span>
            </figcaption>
            {asTable ? table : <div role="img" aria-label={summary}>{chart}</div>}
        </figure>
    );
}
